/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CitiesQueryResponse,
  GetCitiesParams,
  GetStatesParams,
  StatesQueryResponse
} from '../../model';

import { instance } from '../../index';
import type { ErrorType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getStates = (
    params?: GetStatesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<StatesQueryResponse[]>(
      {url: `/api/v1/address/states`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStatesQueryKey = (params?: GetStatesParams,) => {
    return [`/api/v1/address/states`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStatesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getStates>>, GetStatesParams['page']>, TError = ErrorType<unknown>>(params?: GetStatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']> = ({ signal, pageParam }) => getStates({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStatesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStates>>>
export type GetStatesInfiniteQueryError = ErrorType<unknown>


export function useGetStatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getStates>>, GetStatesParams['page']>, TError = ErrorType<unknown>>(
 params: undefined |  GetStatesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getStates>>, GetStatesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getStates>>, GetStatesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetStatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getStates>>, GetStatesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData, Awaited<ReturnType<typeof getStates>>, QueryKey, GetStatesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStatesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStatesQueryOptions = <TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(params?: GetStatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStates>>> = ({ signal }) => getStates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getStates>>>
export type GetStatesQueryError = ErrorType<unknown>


export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params: undefined |  GetStatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStates>>,
          TError,
          Awaited<ReturnType<typeof getStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetStates<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(params?: GetStatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStates>>> = ({ signal }) => getStates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStates>>>
export type GetStatesSuspenseQueryError = ErrorType<unknown>


export function useGetStatesSuspense<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params: undefined |  GetStatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatesSuspense<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatesSuspense<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetStatesSuspense<TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<unknown>>(
 params?: GetStatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStatesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCities = (
    params?: GetCitiesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CitiesQueryResponse[]>(
      {url: `/api/v1/address/cities`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCitiesQueryKey = (params?: GetCitiesParams,) => {
    return [`/api/v1/address/cities`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCitiesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCities>>, GetCitiesParams['page']>, TError = ErrorType<unknown>>(params?: GetCitiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']> = ({ signal, pageParam }) => getCities({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCitiesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCities>>>
export type GetCitiesInfiniteQueryError = ErrorType<unknown>


export function useGetCitiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCities>>, GetCitiesParams['page']>, TError = ErrorType<unknown>>(
 params: undefined |  GetCitiesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCitiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCities>>, GetCitiesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCitiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCities>>, GetCitiesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCitiesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCities>>, GetCitiesParams['page']>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData, Awaited<ReturnType<typeof getCities>>, QueryKey, GetCitiesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCitiesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCitiesQueryOptions = <TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(params?: GetCitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCities>>> = ({ signal }) => getCities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getCities>>>
export type GetCitiesQueryError = ErrorType<unknown>


export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCities>>,
          TError,
          Awaited<ReturnType<typeof getCities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCities<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(params?: GetCitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCities>>> = ({ signal }) => getCities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCities>>>
export type GetCitiesSuspenseQueryError = ErrorType<unknown>


export function useGetCitiesSuspense<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCitiesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCitiesSuspense<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCitiesSuspense<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCitiesSuspense<TData = Awaited<ReturnType<typeof getCities>>, TError = ErrorType<unknown>>(
 params?: GetCitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCities>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCitiesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



